import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { alpha, Box, Container, IconButton, Typography, useTheme } from '@mui/material';
import React, { useId } from 'react';
import { useNavigate } from 'react-router-dom';
import { BusinessProject } from '../../../../MicrospecDynamicUI/Models/Business/BusinessProject';
import { useMicrospecThemeLanguageContext } from '../../../../MicrospecDynamicUI/Themes';
import UpsertProject from './UpsertProject';

const AddProject: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { localizationProvider } = useMicrospecThemeLanguageContext();
  const { translate } = localizationProvider;

  const handleSave = (_project: BusinessProject) => {
    setTimeout(() => {
      window.location.href = '/manager/projects/manage';
    }, 2000);
  };

  const handleCancel = () => {
    navigate('/manager/projects/manage');
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }} key={useId()}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton
          onClick={handleCancel}
          sx={{
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.16) },
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="h4" fontWeight={700}>
            {translate('project.createTitle')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {translate('project.createSubtitle')}
          </Typography>
        </Box>
      </Box>

      <UpsertProject onSave={handleSave} onCancel={handleCancel} />
    </Container>
  );
};

export default AddProject;
